export const fencesUrl = 'fences/';
export const fenceUrl = (fenceId: string) => `fences/${fenceId}/`;
export const fencesFileUrl = 'fences/file/';
// Delivery fences
export const deliveryFencesUrl = 'delivery-fences/';
export const deliveryFenceUrl = (deliveryFenceId: string) => `delivery-fences/${deliveryFenceId}/`;
export const deliveryFencesFileUrl = 'delivery-fences/file/';
